import { ScanBarcode } from "lucide-react";

import { cn } from "@/lib/utils.ts";

import type { ScanReadiness } from "@/lib/scan.ts";

export type { ScanReadiness };

interface Props {
  state: ScanReadiness;
  /** Texto corto: "Lector listo", "Toca aquí para escanear", etc. */
  label: string;
  onClick?: () => void;
  className?: string;
}

const STYLES: Record<ScanReadiness, { pill: string; dot: string; ping: boolean }> = {
  ready: {
    pill: "border-emerald-300 bg-emerald-50 text-emerald-800",
    dot: "bg-emerald-500",
    ping: true,
  },
  reading: {
    pill: "border-emerald-300 bg-emerald-50 text-emerald-800",
    dot: "bg-emerald-500",
    ping: false,
  },
  paused: { pill: "border-red-300 bg-red-50 text-red-700", dot: "bg-red-500", ping: false },
};

/** Semáforo del lector: verde = puede escanear, rojo = la lectura no entra. */
export function ScanStatus({ state, label, onClick, className }: Props) {
  const style = STYLES[state];
  return (
    <button
      type="button"
      onClick={onClick}
      tabIndex={onClick ? 0 : -1}
      role="status"
      aria-live="polite"
      className={cn(
        "inline-flex shrink-0 items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-semibold whitespace-nowrap",
        style.pill,
        !onClick && "cursor-default",
        className,
      )}
    >
      <span className="relative flex h-2.5 w-2.5">
        {style.ping && (
          <span
            className={cn(
              "absolute inline-flex h-full w-full animate-ping rounded-full opacity-75",
              style.dot,
            )}
          />
        )}
        <span className={cn("relative inline-flex h-2.5 w-2.5 rounded-full", style.dot)} />
      </span>
      <ScanBarcode className="h-3.5 w-3.5" />
      {label}
    </button>
  );
}
